/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, intlShape, defineMessages} from 'react-intl';

import {LoadingSpinner} from 'eui-components';

import styles from './LoadingIndicator.css';

const messages = defineMessages({
  defaultMessage: {
    id: 'LoadingIndicator.defaultMessage',
    description: 'Default loading indicator message.',
    defaultMessage: 'Loading...'
  }
});

const LoadingIndicator = (props) => {
  return (
      <div className={styles.loadingIndicatorContainer}>
        <LoadingSpinner/>
        <p>{props.message || props.intl.formatMessage(messages.defaultMessage)}</p>
      </div>
  );
};

LoadingIndicator.propTypes = {
  message: PropTypes.string,
  intl: intlShape.isRequired
};

export default injectIntl(LoadingIndicator);



// WEBPACK FOOTER //
// ./src/LoadingIndicator/LoadingIndicator.js